export function runIntersectionObserver() {

  const theObserver = document.querySelectorAll('[data-animation="base"]');
  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: [0.01, 0.5],
  };

  const animationDelay = 100;

  const observerCallback = (entries, observer) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        const delay =
          parseInt(entry.target.getAttribute("data-animated-delay")) || 0;
        setTimeout(() => {
          entry.target.classList.add("scroll-animation");
        }, index * animationDelay + delay);
        // observer.unobserve(entry.target);
        // console.log("isIntersecting:", entry.target);
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  theObserver.forEach((element) => {
    observer.observe(element);
  });

}
